<script>
    import PageLayout from '$lib/PageLayout.svelte';
    import { page } from '$app/stores';
    import Breadcrumbs from '$lib/Breadcrumbs.svelte';
    import Form from '$lib/Form.svelte';
    import CourseHero from '$lib/CourseHero.svelte';

    import Reviews2 from '$lib/Reviews2.svelte';
    import ScrollableSection from '$lib/ScrollableSection.svelte';
    import Card from '$lib/Card.svelte';
    import Prose from '$lib/Prose.svelte';
    import Bundles from '$lib/Bundles.svelte';
    import PageSection from '$lib/PageSection.svelte';
    import Faq2 from '$lib/FAQ2.svelte';
    import Award from '$lib/Award.svelte';
    import MoneyBack from '$lib/MoneyBack.svelte';

    /** @type {Course} */
    let course = $page.data.course;

</script>

<PageLayout>
    <Breadcrumbs />

    {#if course?.trailer_playback_id}
        <CourseHero
            {course}
            title={course.title}
            text={course.lead}
            playback_id={course.trailer_playback_id}
            thumbnail_time={course.trailer_thumbnail_time}
            feature="course-hero"
            header_tag="h1"
            class="container mx-auto px-4 md:px-8 mb-8 md:mb-12"
        />

        <div class="bg-black py-6 my-9">
            <ScrollableSection
                class="max-w-screen w-full"
                content_class="w-fit mx-auto max-w-full flex"
            >
                <Award class="flex-shrink-0 snap-start self-start mt-8 px-4" />

                <MoneyBack class="flex-shrink-0 snap-start self-start mx-4" />

                {#if $page.data.reviews?.length}
                    <Reviews2
                        reviews={$page.data.reviews}
                        class="contents"
                        review_class="w-[300px] flex-shrink-0 snap-start px-4 box-content last:pr-16"
                    />
                {/if}
            </ScrollableSection>
        </div>
    {/if}

    <PageSection>
        <div class="flex flex-col lg:flex-row gap-4">
            <Prose lg class="flex-1 flex-shrink-0">
                {#if !course?.trailer_playback_id}
                    <h1>{@html course.title}</h1>
                    {@html course.lead}
                {/if}

                {@html course.description}
            </Prose>

            {#if $page.data.faq}
                <div class="flex-1">
                    <Faq2 class="mb-8 max-w-none" />
                </div>
            {/if}
        </div>
    </PageSection>

    {#if !course.purchased && course.price}
        <PageSection class="my-12 flex flex-col gap-4 md:gap-6">
            <Bundles course_slug={course.slug} class="max-w-screen-md" feature="bundle-list-course" />
        </PageSection>
    {/if}

    <PageSection>
        {#if !course.purchased && (!course.price || !course.lessons.length)}
            <hr class="my-12 border-white/15" />
            <div id="form" />
            <Card class="lg:p-8">
                <Form
                    class="max-w-xl mx-auto"
                    form_name={course.slug}
                    label_text="Want us to notify you when {course.title} becomes available? Leave your email below:"
                    cta_text="Join the waitlist"
                    success_message="Thanks! We'll let you know when {course.title} is available."
                />
            </Card>
        {/if}
    </PageSection>
</PageLayout>
